import styles from './ui.module.css';

export type GapStep = 's1' | 's1h' | 's2' | 's2h' | 's3' | 's4' | 's5' | 's6' | 's7';

const STEP: Record<GapStep, string> = {
  s1: styles.gapS1,
  s1h: styles.gapS1h,
  s2: styles.gapS2,
  s2h: styles.gapS2h,
  s3: styles.gapS3,
  s4: styles.gapS4,
  s5: styles.gapS5,
  s6: styles.gapS6,
  s7: styles.gapS7,
};

/**
 * Шаг по вертикали между соседями ВНУТРИ коробки — ступенью шкалы, а не
 * числом. Заменил вкуишный `Spacing`: тот брал любое число и клал его в
 * атрибут style. Между разделами ритм держит `Section`, туда `Gap` не ставят.
 */
export function Gap({ step }: { step: GapStep }) {
  return <div className={STEP[step]} />;
}
